import { Stack } from '@mui/material';
import Footnote from './Footnote';

interface FootnotesListProps {
  footnotes: Node[];
}

export default function FootnotesList({ footnotes }: FootnotesListProps) {
  return (
    <Stack spacing={4} id={'footnotes'}>
      {footnotes.map((footnote, index) => {
        return (
          <Footnote
            key={'footnote-' + (index + 1)}
            footnote={footnote as HTMLElement}
            number={index + 1}
          />
        );
      })}
    </Stack>
  );
}
